import {playSplitText, playFade} from '../common/help_functions';


export function initMissionSectionType1(element) {
    playFade('.mission-type-1-section .number')
    playSplitText('.mission-type-1-section .title', true)
    playFade('.mission-type-1-section .content-text')
}
